// @flow

import { MediaQuery } from '@riseart/common';
import { Col, Row } from '@riseart/antd-provider';
import { FilterExpandable, FilterExpandableContent } from '@riseart/filter';
import {
  CLEAR_BUTTON_TYPE,
  CLEAR_LINK_TYPE,
  FILTER_ITEM_TYPE,
  FILTER_EXPANDABLE_FOOTER_TYPE,
  SEARCH_LINK,
} from 'shared_models/filters/preconfigTypes';
import { sortByLabel } from 'shared_services/riseart/utils/Utils.js';

import {
  raScreenSmMax,
  raScreenMd,
  raScreenLgMax,
  raScreenXl,
} from '@riseart/antd-provider/dist/website/variables.less';
import { filterColCenterCls } from 'shared_models/filters/styles.less';

export const ArtistListFilterModel = [
  {
    type: MediaQuery,
    props: { minWidth: 0 },
    items: [
      {
        type: MediaQuery,
        props: { maxWidth: raScreenSmMax },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 12 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: { dimension: 'medium', showLabel: false, align: 'left' },
                  },
                ],
              },
              {
                type: Col,
                props: { span: 12 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'initial', showLabel: false } }],
              },
              {
                type: Col,
                props: { span: 12 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: { dimension: 'style', showLabel: false, align: 'left' },
                  },
                ],
              },
              {
                type: Col,
                props: { span: 12 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: { dimension: 'born', showLabel: false, sort: sortByLabel },
                  },
                ],
              },
            ],
          },
          {
            type: FilterExpandable,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: FilterExpandableContent,
                items: [
                  {
                    type: Row,
                    props: { type: 'flex', justify: 'space-between', gutter: 32 },
                    items: [
                      {
                        type: Col,
                        props: { span: 12 },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: {
                              dimension: 'region',
                              showLabel: false,
                              align: 'left',
                            },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 12 },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: {
                              dimension: 'ships',
                              showLabel: false,
                              sort: sortByLabel,
                              align: 'left',
                            },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 12 },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: { dimension: 'stage', showLabel: false, align: 'left' },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 8, className: filterColCenterCls },
                        items: [
                          { ...FILTER_ITEM_TYPE, props: { dimension: 'gender', showLabel: false } },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 4, align: 'right' },
                        items: [SEARCH_LINK],
                      },
                    ],
                  },
                ],
              },
              {
                ...FILTER_EXPANDABLE_FOOTER_TYPE,
                items: [CLEAR_LINK_TYPE],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenMd, maxWidth: raScreenLgMax },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'medium', align: 'left' } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'initial' } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: {
                      dimension: 'born',
                      sort: sortByLabel,
                    },
                  },
                ],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'style', align: 'left' } }],
              },

              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'region' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'gender' } }],
              },
              {
                type: Col,
                props: { span: 2, align: 'right' },
                items: [SEARCH_LINK],
              },
            ],
          },
          {
            type: FilterExpandable,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: FilterExpandableContent,
                items: [
                  {
                    type: Row,
                    props: { type: 'flex', justify: 'flex-start', gutter: 32 },
                    items: [
                      {
                        type: Col,
                        props: { span: 8, align: 'left' },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: {
                              dimension: 'ships',
                              sort: sortByLabel,
                            },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 8 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'stage' } }],
                      },
                    ],
                  },
                ],
              },
              {
                ...FILTER_EXPANDABLE_FOOTER_TYPE,
                items: [CLEAR_LINK_TYPE],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenXl },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'medium' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'style' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'initial' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: {
                      dimension: 'born',
                      sort: sortByLabel,
                    },
                  },
                ],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'region' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'stage' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: {
                      dimension: 'ships',
                      sort: sortByLabel,
                    },
                  },
                ],
              },
              {
                type: Col,
                props: { span: 2 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'gender' } }],
              },
              {
                type: Col,
                props: { span: 2, align: 'right' },
                items: [SEARCH_LINK],
              },
              {
                type: Col,
                props: { span: 2 },
                items: [CLEAR_BUTTON_TYPE],
              },
            ],
          },
        ],
      },
    ],
  },
];
